import getters from './getters';
import actions from './actions';

const module = {
  getters,
  actions,
};

export default module;
